import { LinkTo } from '@ember/routing';

import Application from 'market-view-ui/components/application';

<template>
  <Application>
    <article class="l-page">
      <section class="page__content">
        <LinkTo @route="application" class="page__back-link">
          &larr;Back to Market View
        </LinkTo>
        <h1 class="page__headline-primary">Uh oh, looks like the dog ate our web
          page.
        </h1>
        <p class="t-body">This page does not exist.
          <LinkTo @route="application">Head back to the homepage.</LinkTo></p>
      </section>
    </article>
  </Application>
</template>
